namespace GeniuzPOS.Purchase {
    export class PoPurOrderAppColumns {
        static columnsKey = 'Purchase.PoPurOrderApp';
    }
}
